var React = require('react');

function ToggleView (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"icon-/-thumb","stroke":"#000000","style":{"mixBlendMode":"exclusion"}},[React.createElement("rect",{"id":"Rectangle","x":"0.5","y":"0.5","width":"6","height":"4","key":0}),React.createElement("rect",{"id":"Rectangle-Copy-6","x":"9.5","y":"0.5","width":"6","height":"4","key":1}),React.createElement("rect",{"id":"Rectangle-Copy-7","x":"9.5","y":"7.5","width":"6","height":"4","key":2}),React.createElement("rect",{"id":"Rectangle-Copy-8","x":"0.5","y":"7.5","width":"6","height":"4","key":3})])));
}

ToggleView.defaultProps = {"viewBox":"0 0 16 12","version":"1.1"};

module.exports = ToggleView;

ToggleView.default = ToggleView;
